<template>
  <div>
    <h1>this is the subscription page</h1>
    <div class="main-content">
    

      <div>
        <div class="mt--8 pb-5">
          <div class="row justify-content-center">
            <div class="col-lg-10">
              <div
                class="pricing card-group flex-column flex-md-row mb-3"
                style="margin-top:100px;"
              >
                <div
                  class="card card-pricing border-0 text-center mb-4"
                  style=" margin-right:20px;"
                >
                  <div class="card-header bg-transparent">
                    <h4 class="text-uppercase ls-1 text-primary py-3 mb-0">Bravo pack</h4>
                  </div>
                  <div class="card-body px-lg-7">
                    <div class="display-2">$49</div>
                    <span class="text-muted">per application</span>
                    <ul class="list-unstyled my-4">
                      <li>
                        <div class="d-flex align-items-center">
                          <div>
                            <div
                              class="icon icon-xs icon-shape bg-gradient-primary shadow rounded-circle text-white"
                            >
                              <i class="fas fa-terminal"></i>
                            </div>
                          </div>
                          <div>
                            <span class="pl-2">Complete documentation</span>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="d-flex align-items-center">
                          <div>
                            <div
                              class="icon icon-xs icon-shape bg-gradient-primary shadow rounded-circle text-white"
                            >
                              <i class="fas fa-pen-fancy"></i>
                            </div>
                          </div>
                          <div>
                            <span class="pl-2">Working materials in Sketch</span>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="d-flex align-items-center">
                          <div>
                            <div
                              class="icon icon-xs icon-shape bg-gradient-primary shadow rounded-circle text-white"
                            >
                              <i class="fas fa-hdd"></i>
                            </div>
                          </div>
                          <div>
                            <span class="pl-2">2GB cloud storage</span>
                          </div>
                        </div>
                      </li>
                    </ul>
                    <button data-v-39443e00 type="button" class="btn mb-3 btn-primary">
                      <!---->
                      Start free trial
                    </button>
                  </div>
                  <!---->
                  <div class="card-footer">
                    <a href="#!" class="text-light">Request a demo</a>
                  </div>
                </div>
                <div
                  class="card card-pricing zoom-in shadow-lg rounded border-0 text-center mb-4 bg-gradient-info"
                >
                  <div class="card-header bg-transparent">
                    <h4 class="text-uppercase ls-1 text-white py-3 mb-0">Alpha pack</h4>
                  </div>
                  <div class="card-body px-lg-7">
                    <div class="display-1 text-white">$199</div>
                    <span class="text-white">per application</span>
                    <ul class="list-unstyled my-4">
                      <li>
                        <div class="d-flex align-items-center">
                          <div>
                            <div
                              class="icon icon-xs icon-shape bg-white shadow rounded-circle text-muted"
                            >
                              <i class="fas fa-terminal"></i>
                            </div>
                          </div>
                          <div>
                            <span class="pl-2 text-white">Complete documentation</span>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="d-flex align-items-center">
                          <div>
                            <div
                              class="icon icon-xs icon-shape bg-white shadow rounded-circle text-muted"
                            >
                              <i class="fas fa-pen-fancy"></i>
                            </div>
                          </div>
                          <div>
                            <span class="pl-2 text-white">Working materials in Sketch</span>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="d-flex align-items-center">
                          <div>
                            <div
                              class="icon icon-xs icon-shape bg-white shadow rounded-circle text-muted"
                            >
                              <i class="fas fa-hdd"></i>
                            </div>
                          </div>
                          <div>
                            <span class="pl-2 text-white">2GB cloud storage</span>
                          </div>
                        </div>
                      </li>
                    </ul>
                    <button data-v-39443e00 type="button" class="btn mb-3 btn-secondary">
                      <!---->
                      Start free trial
                    </button>
                  </div>
                  <!---->
                  <div class="card-footer bg-transparent">
                    <a href="#!" class="text-white">Contact sales</a>
                  </div>
                </div>
                <div class="card card-pricing border-0 text-center mb-4" style=" margin-left:20px;">
                  <div class="card-header bg-transparent">
                    <h4 class="text-uppercase ls-1 text-primary py-3 mb-0">Bravo pack</h4>
                  </div>
                  <div class="card-body px-lg-7">
                    <div class="display-2">$699</div>
                    <span class="text-muted">per application</span>
                    <ul class="list-unstyled my-4">
                      <li>
                        <div class="d-flex align-items-center">
                          <div>
                            <div
                              class="icon icon-xs icon-shape bg-gradient-primary shadow rounded-circle text-white"
                            >
                              <i class="fas fa-terminal"></i>
                            </div>
                          </div>
                          <div>
                            <span class="pl-2">Complete documentation</span>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="d-flex align-items-center">
                          <div>
                            <div
                              class="icon icon-xs icon-shape bg-gradient-primary shadow rounded-circle text-white"
                            >
                              <i class="fas fa-pen-fancy"></i>
                            </div>
                          </div>
                          <div>
                            <span class="pl-2">Working materials in Sketch</span>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="d-flex align-items-center">
                          <div>
                            <div
                              class="icon icon-xs icon-shape bg-gradient-primary shadow rounded-circle text-white"
                            >
                              <i class="fas fa-hdd"></i>
                            </div>
                          </div>
                          <div>
                            <span class="pl-2">2GB cloud storage</span>
                          </div>
                        </div>
                      </li>
                    </ul>
                    <button data-v-39443e00 type="button" class="btn mb-3 btn-primary">
                      <!---->
                      Start free trial
                    </button>
                  </div>
                  <!---->
                  <div class="card-footer">
                    <a href="#!" class="text-light">Request a demo</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>